import { render } from "./CustomComponentsContainer.vue?vue&type=template&id=e55c8f78"
import script from "./CustomComponentsContainer.vue?vue&type=script&lang=js"
export * from "./CustomComponentsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__